import { render, staticRenderFns } from "./CSpinner.vue?vue&type=template&id=084f2866&"
import script from "./CSpinner.vue?vue&type=script&lang=js&"
export * from "./CSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports